import { ReactElement } from 'react';

import {
   AuthorizationFailedFault,
   CurrentHealthcareProviderPaymentsConfigurationCreateCommand,
   CurrentHealthcareProviderPaymentsConfigurationQuery,
} from '@dreryk/egabinet-online-payments-integration-frontend-api';

import { refetchCqrsQuery, useCqrsCommand } from '@dreryk/command-query-react-common';
import { createInterpolatedTranslationKey, PromiseVoidFunction } from '@dreryk/react-common';
import { dispatchSnackbarNegativeEvent, dispatchSnackbarPositiveEvent } from '@dreryk/react-components';

import { onlinePaymentsIntegrationTranslationKeys } from '../../translations';

import {
   OnlinePaymentsIntegrationFormBean,
   OnlinePaymentsIntegrationFormController,
} from './OnlinePaymentsIntegrationForm.types';

type OnlinePaymentsConfigurationCreateActionChildrenRenderProps = {
   readonly createConfiguration: PromiseVoidFunction;
};

type OnlinePaymentsConfigurationCreateActionProps = Pick<OnlinePaymentsIntegrationFormController, 'handleSubmit'> & {
   readonly children: (renderProps: OnlinePaymentsConfigurationCreateActionChildrenRenderProps) => ReactElement;
};

export const OnlinePaymentsConfigurationCreateAction = (
   props: OnlinePaymentsConfigurationCreateActionProps
): ReactElement => {
   const { executeAsync: createOnlinePaymentsConfiguration } = useCqrsCommand<
      void,
      OnlinePaymentsIntegrationFormBean,
      AuthorizationFailedFault
   >(
      (parameters) => {
         const command = new CurrentHealthcareProviderPaymentsConfigurationCreateCommand();
         command.clientId = parameters.clientId;
         command.clientSecret = parameters.clientSecret;
         command.posId = parameters.posId;
         command.secondKey = parameters.secondKey;
         command.termsOfService = parameters.termsOfService!;
         return command;
      },
      {
         onSuccess: () => {
            dispatchSnackbarPositiveEvent(
               onlinePaymentsIntegrationTranslationKeys.actions.createConfiguration.successMessage
            );
            refetchCqrsQuery(CurrentHealthcareProviderPaymentsConfigurationQuery);
         },
         onFault: {
            'egabinet-online-payments-integration-frontend-api:AuthorizationFailedFault': ({ errorCode }) => {
               dispatchSnackbarNegativeEvent(
                  createInterpolatedTranslationKey(
                     onlinePaymentsIntegrationTranslationKeys.actions.createConfiguration.failureMessage,
                     {
                        errorCode: errorCode,
                     }
                  )
               );
            },
         },
      }
   );

   return props.children({
      createConfiguration: props.handleSubmit(createOnlinePaymentsConfiguration),
   });
};
